import { useClientConfiguration } from "../data/global/useProductConfiguration";

const useHasHcpAccessAsFrm = (client: string, isFrm: boolean) => {
  const config = useClientConfiguration(client);

  return config.hasHcpAccessAsFrm && isFrm;
};

export default useHasHcpAccessAsFrm;
